import * as actions from './battles.actions'

const initialState = {
  currentBattle: false,
  question: null,
  battleResume: null,
  results: null,
  info: {
    hits: 0,
    fails: 0,
    question: 1,
  },
  userBattles: [],
  allUserBattles: [],
  loading: false,
  individualBattle: null,
}

const actionsMap = {
  [actions.SET_BATTLE]: (state, action) => {
    const battle = action.data

    return {
      ...state,
      currentBattle: battle,
    }
  },
  [actions.SET_INDIVIDUAL_BATTLE]: (state, action) => {
    const battle = action.data

    return {
      ...state,
      individualBattle: battle,
    }
  },
  [actions.SET_USER_BATTLES]: (state, action) => {
    const battles = action.data

    return {
      ...state,
      userBattles: battles,
    }
  },
  [actions.SET_ALL_USER_BATTLES]: (state, action) => {
    const allBattles = action.data

    return {
      ...state,
      allUserBattles: allBattles,
    }
  },
  [actions.SET_BATTLE_QUESTION]: (state, action) => {
    const question = action.data

    return {
      ...state,
      question: question,
      loading: false,
    }
  },
  [actions.SET_BATTLE_INFO]: (state, action) => {
    const info = action.data

    return {
      ...state,
      info: info,
    }
  },
  [actions.SET_BATTLE_RESUME]: (state, action) => {
    const resume = action.data

    return {
      ...state,
      battleResume: resume,
    }
  },
  [actions.SET_BATTLE_RESULTS]: (state, action) => {
    const results = action.data

    return {
      ...state,
      results: results,
    }
  },
  [actions.ANSWER_BATTLE_QUESTION]: (state) => ({
    ...state,
    loading: true,
  }),
}

/* eslint require-jsdoc: 0 */
export default function reducer(state = initialState, action = {}) {
  const fn = actionsMap[action.type]
  return fn ? fn(state, action) : state
}
